
























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  getReadPeopleReq,
  getReadPeopleByPersonReq
} from '@/api/common'
@Component
export default class Commit extends Vue {
  //计划id
  @Prop({ type: String, default: '', required: true })
  planId!: string
  //计划类型 1年计划 2月计划 3周计划 4日计划
  @Prop({ type: Number, default: '', required: false })
  planType!: number
  //评论类型 1 点赞 2评论
  type: number = 1
  //评论列表
  @Watch('planId')
  handleValueChange2(val: any) {
    this.getCommitList()
  }
  private content: string = ''
  private zanId: string = ''
  commitRecordList: any = []
  get userId() {
    return this.$store.state.user.userInfo.id
  }
  get isNaturePersonVersion() {
    return this.$store.getters['user/isNaturePersonVersion']
  }
  mounted() {
    this.getCommitList()
  }
 
  //获取已读列表
  async getCommitList() {
    if (this.isNaturePersonVersion) {
      const [err, data] = await getReadPeopleByPersonReq(this.planId)
    if (!err) {
      this.commitRecordList = data ? data : []
      //this.commitRecordList.push(...data)
    } 
    } else {
      const [err, data] = await getReadPeopleReq(this.planId)
    if (!err) {
      this.commitRecordList = data ? data : []
      //this.commitRecordList.push(...data)
    } 
    }
  }
  private showMore:boolean =  false
  handleMore() {
    this.showMore = !this.showMore
  }

}
